module.exports = __webpack_public_path__ + "static/media/ok_icon_big.b51581e9.svg";